import * as _ from 'lodash';

import DecimalForGlobals from './DecimalForGlobals';

class ComprobanteGlobalImpuestosCalculator {
  data = {};

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new ComprobanteGlobalImpuestosCalculator(data);
  }

  apply() {
    let items = _.get(this.data, 'Conceptos.Concepto') || [];

    const traslados = this._getTraslados(items);
    const retenciones = this._getRetenciones(items);

    return {
      ...traslados,
      ...retenciones,
    };
  }

  _getTraslados(items) {
    let totalTrasladado = 0;
    let traslados = {};

    for (const item of items) {
      let impuestos = _.get(item, 'Impuestos.Traslados.Traslado') || [];

      for (const impuesto of impuestos) {
        if (impuesto.TipoFactor === 'Exento') {
          const index = `${impuesto.Impuesto}-${impuesto.TipoFactor}`;
          let traslado = traslados[index];

          if (!!traslado) {
            const base = parseFloat(traslado.Base || 0) + parseFloat(impuesto.Base || 0);

            traslado.Base = base;
          } else {
            traslado = {
              Base: impuesto.Base,
              Importe: undefined,
              Impuesto: impuesto.Impuesto,
              TipoFactor: impuesto.TipoFactor,
            };
          }

          traslados = {
            ...traslados,
            [index]: traslado,
          };

          continue;
        }

        totalTrasladado += parseFloat(impuesto.Importe || 0);

        const index = `${impuesto.Impuesto}-${impuesto.TipoFactor}-${impuesto.TasaOCuota}`;
        let traslado = traslados[index];

        if (!!traslado) {
          const importe = parseFloat(traslado.Importe || 0) + parseFloat(impuesto.Importe || 0);
          const base = parseFloat(traslado.Base || 0) + parseFloat(impuesto.Base || 0);

          traslado.Importe = importe;
          traslado.Base = base;
        } else {
          traslado = {
            Base: impuesto.Base,
            Impuesto: impuesto.Impuesto,
            TipoFactor: impuesto.TipoFactor,
            TasaOCuota: impuesto.TasaOCuota,
            Importe: impuesto.Importe,
          };
        }

        traslados = {
          ...traslados,
          [index]: traslado,
        };
      }
    }

    traslados = Object.values(traslados);

    if (traslados.length === 0) {
      return {};
    }

    return {
      TotalImpuestosTrasladados: DecimalForGlobals.make(totalTrasladado).toFixed(),
      Traslados: {
        Traslado: traslados.map((item) => {
          item.Base = DecimalForGlobals.make(item.Base).toFixed();

          if (item.TipoFactor !== 'Exento') {
            item.Importe = DecimalForGlobals.make(item.Importe).toFixed();
          }

          return item;
        }),
      },
    };
  }

  _getRetenciones(items) {
    let totalRetenido = 0;
    let retenciones = {};

    for (const item of items) {
      let impuestos = _.get(item, 'Impuestos.Retenciones.Retencion') || [];

      for (const impuesto of impuestos) {
        if (impuesto.TipoFactor === 'Exento') {
          continue;
        }

        totalRetenido += parseFloat(impuesto.Importe || 0);

        const index = `${impuesto.Impuesto}-${impuesto.TipoFactor}-${impuesto.TasaOCuota}`;
        let retencion = retenciones[index];

        if (!!retencion) {
          const importe = parseFloat(retencion.Importe || 0) + parseFloat(impuesto.Importe || 0);

          retencion.Importe = importe;
        } else {
          retencion = {
            Impuesto: impuesto.Impuesto,
            Importe: impuesto.Importe,
          };
        }

        retenciones = {
          ...retenciones,
          [index]: retencion,
        };
      }
    }

    retenciones = Object.values(retenciones);

    if (retenciones.length === 0) {
      return {};
    }

    return {
      TotalImpuestosRetenidos: DecimalForGlobals.make(totalRetenido).toFixed(),
      Retenciones: {
        Retencion: retenciones.map((item) => {
          item.Importe = DecimalForGlobals.make(item.Importe).toFixed();

          return item;
        }),
      },
    };
  }
}

export default ComprobanteGlobalImpuestosCalculator;
